(function () {
  'use strict';

  angular.module('sempraWebapp').component('reportBuilderTableView', {
    templateUrl:
      'app/reportsBuilderKarcher/reportBuilderTableView/reportBuilderTableView.html',
    controller: reportBuilderTableView,
    bindings: {
      reportBuilderTableViewData: '<',
      reportBodyData: '<',
      paginationParams: '&'
    },
    controllerAs: 'vm'
  });

  function reportBuilderTableView($translate) {
    var vm = this;
    // GRID CONFIG
    vm.tablePageOptions = [2, 10, 20, 50];
    vm.pagerTranslations = {
      page: $translate.instant('GRID_PAGER_PAGE'),
      rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
      of: $translate.instant('GRID_PAGER_PAGE_OF')
    };

    vm.$onInit = function () {};

    vm.$onChanges = function (changes) {
      switch (true) {
        case changes.hasOwnProperty('reportBuilderTableViewData') && changes.hasOwnProperty('reportBodyData'):
          vm.tableData = changes.reportBuilderTableViewData.currentValue;
          vm.tableData.columnNames = Object.keys(vm.tableData.data[0]);
          vm.tableOrderBy = changes.reportBodyData.currentValue.sortBy;
          vm.tableOrder = changes.reportBodyData.currentValue.sortDir;
          vm.tablePageSize = changes.reportBodyData.currentValue.pageSize;
          vm.tablePage = changes.reportBodyData.currentValue.page + 1;
          break;
        case changes.hasOwnProperty('reportBuilderTableViewData'):
          vm.tableData = changes.reportBuilderTableViewData.currentValue;
          vm.tableData.columnNames = Object.keys(vm.tableData.data[0]);
          break;
        case changes.hasOwnProperty('reportBodyData'):
          vm.tableOrderBy = changes.reportBodyData.currentValue.sortBy;
          vm.tableOrder = changes.reportBodyData.currentValue.sortDir;
          vm.tablePageSize = changes.reportBodyData.currentValue.pageSize;
          vm.tablePage = changes.reportBodyData.currentValue.page + 1;
          break;
      }
    };

    vm.pageChanged = function (page, limit) {
      vm.paginationParams({ page: page, limit: limit });
    };
  }
})();
